<template lang="pug">
  .container.solicitarPermuta
    div.content-cadastro
      app-listagem(
        :tituloCard="tituloCard"
        :hasActionButton="true"
        :sizeActionButton="sizeActionButton"
        :nameActionButton="nameActionButton"
        :hasHeader="true"
        :hasRefreshButton="false"
        :headerLabel="headerLabel"
        :dataForTable="cadastros"
        :totalElements="totalCadastros"
        :pagina="pagina"
        @click="novoCadastro"
        @changePage="changePage"
      )
        template(slot="columns")
          el-table-column(
            label="Nome/Razão social do interessado",
            prop="nomeRazaoSocial"
            sortable
          )
          el-table-column(
            label="CPF/CNPJ do interessado",
            :formatter="interessadoFormatCpfCnpj"
          )
          el-table-column(
            label="Nome/Razão social do cadastrante"
            :formatter="cadastranteFormatNome"
          )
          el-table-column(
            label="Data de atualização",
            width="160",
            :formatter="setData",
          )
          el-table-column(
            label="Ações",
            width="110",
            align="center"
          )
            template(slot-scope='scope')
              el-dropdown(trigger="click", size="small")
                el-button(type='primary', size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                  div.oi
                    el-dropdown-item
                      .flex(@click="$router.push({name: 'permuta/cadastrante', params: { idCadastro: scope.row.id }})")
                        i.fal.fa-pencil-alt
                        | &nbsp Editar Cadastro
                  div.oi
                    el-dropdown-item
                      .flex(@click="remove(scope.row)")
                        i.fa.fa-times
                        | &nbsp Remover Cadastro
</template>

<script>
import { mapActions } from 'vuex'
import AppCabecalho from '@/components/AppCabecalho'
import AppListagemCadastros from '../../../components/cadastro/AppListagemCadastros'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/shared/AppListagem'
import moment from 'moment'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppCabecalho,
    AppListagemCadastros,
    AppListagem
  },

  mounted () {
    this.loadLista({ newPage: 0 })
  },

  data () {
    return {
      pagina: 1,
      tituloCard: 'Solicitar permuta',
      headerLabel: 'Listagem de solicitações',
      sizeActionButton: 'medium',
      nameActionButton: 'Cadastrar',
      totalCadastros: 0,
      cadastros: []
    }
  },

  methods: {
    ...mapActions({
      getCadastros: 'listagem/getItems',
      count: 'listagem/count',
      delete: 'listagem/delete'
    }),

    async loadLista ({ newPage }) {
      this.cadastros = await this.getCadastros({ tipoCadastro: 'PERMUTA', numeroPagina: newPage })
      this.cadastros = _.orderBy(this.cadastros, ['data'], ['desc']) // eslint-disable-line

      this.cadastros.forEach(cadastro => {
        cadastro.nomeRazaoSocial = this.setNomeRazao(cadastro)
      })

      this.totalCadastros = await this.count('PERMUTA')
    },

    interessadoFormatCpfCnpj (row, column, prop) {
      if (!row) {
        return '-'
      }
      const pessoa = JSON.parse(row.pessoaInteressado)
      return pessoa.tipo === 'PF' ? pessoa.pessoaFisica.cpf || '-' : pessoa.pessoaJuridica.cnpj || '-'
    },

    setNomeRazao (cadastro) {
      if (!cadastro) {
        return '-'
      }
      const pessoa = JSON.parse(cadastro.pessoaInteressado)
      return pessoa.tipo === 'PF' ? pessoa.pessoaFisica.nome || '-' : pessoa.pessoaJuridica.razaoSocial || '-'
    },

    interessadoFormatNome (row, column, prop) {
      if (!row) {
        return '-'
      }
      const pessoa = JSON.parse(row.pessoaInteressado)
      return pessoa.tipo === 'PF' ? pessoa.pessoaFisica.nome || '-' : pessoa.pessoaJuridica.razaoSocial || '-'
    },

    cadastranteFormatNome (row, column, prop) {
      if (!row) {
        return '-'
      }
      const pessoa = JSON.parse(row.pessoaCadastrante).pessoa
      return pessoa.nomeRazaoSocial || '-'
    },

    setData (row) {
      if (row.data) {
        return moment(row.data).format('HH:mm:ss') + ' ' + moment(row.data).format('DD/MM/YYYY')
      }
      return '-'
    },

    novoCadastro () {
      this.$router.push({
        name: 'cadastro/permuta/new'
      })
    },

    changePage (newPage) {
      this.pagina = newPage
      this.loadLista({ newPage: newPage - 1 })
    },

    updateListagem () {
      this.changePage(1)
    },

    async remove (object) {
      this.confirmBox('Depois de removido, não será possível recuperar este cadastro. Tem certeza que deseja remover este cadastro?',
        this.$messages.TITULO_WARNING,
        async () => {
          await this.delete(object.id)
          this.changePage(1)
        },
        () => {
        }, 'Confimar', 'Cancelar')
    }
  }
}

</script>

<style lang="scss" scoped>
.content-cadastro {
  padding: 20px;
  width: 100%;
}

@media (max-width: 780px) {
  .content-cadastro {
    width: 360px !important;
  }
  .solicitarPermuta {
    position: relative;
    top: 70px;
    right: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/permuta/Home.vue